/**
 * Sprint 17 B1: Webhook Node — HTTP callback indicator
 */
import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";
import { Webhook } from "lucide-react";
import type { WebhookNodeData } from "./types";

interface WebhookNodeProps {
  node: WebhookNodeData;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function WebhookNode({ node, isSelected, onSelect }: WebhookNodeProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(node.id)}
      className={cn(
        "flex flex-col gap-1 rounded-lg border-2 px-4 py-3 text-left shadow-sm transition-colors min-w-[200px]",
        "bg-[var(--color-surface)] border-[var(--color-border)] hover:border-[var(--color-muted-foreground)]",
        isSelected && "ring-2 ring-[var(--color-ring)] border-[var(--color-muted-foreground)]",
      )}
    >
      <div className="flex items-center gap-2">
        <Webhook className="h-4 w-4 text-[var(--color-muted-foreground)]" />
        <span className="text-xs font-medium text-[var(--color-muted-foreground)] uppercase">
          {t("journey.node.webhook")}
        </span>
        <span className="text-[10px] bg-[var(--color-surface)] border border-[var(--color-border)] text-[var(--color-muted-foreground)] rounded px-1.5 py-0.5 ml-auto">
          {node.method}
        </span>
      </div>
      {node.url && (
        <div className="text-xs text-[var(--color-muted-foreground)] truncate max-w-[240px] font-mono">
          {node.url}
        </div>
      )}
    </button>
  );
}
